import { setCookie, getCookie } from './cookie';

const TTCLID_COOKIE_NAME = '_ttclid';
const TTCLID_COOKIE_EXPIRATION_DAYS = 90;
const TTP_COOKIE_NAME = '_ttp';

/**
 * Captures the TikTok click ID (ttclid) from the URL and stores it in a
 * first-party cookie.
 */
export function captureTiktokClickId(): void {
    if (typeof window === 'undefined') {
        return;
    }

    const params = new URLSearchParams(window.location.search);
    const ttclid = params.get('ttclid');

    if (ttclid) {
        setCookie(TTCLID_COOKIE_NAME, ttclid, TTCLID_COOKIE_EXPIRATION_DAYS);
    }
}

/** Returns the stored TikTok click ID, or null if not present. */
export function getTiktokClickId(): string | null {
    return getCookie(TTCLID_COOKIE_NAME);
}

/** Returns the TikTok browser ID set by the TikTok Pixel, or null if not present. */
export function getTiktokBrowserId(): string | null {
    return getCookie(TTP_COOKIE_NAME);
}
